import { makeStyles } from '@material-ui/core/styles';

export const useReportIssueBaseStyles = makeStyles(() => ({
  container: {
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    width: '100%',
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    padding: (props) => (props.mobile ? '' : '30px 70px'),
  },
  button: {
    margin: '0 auto',
    textAlign: 'center',
  },
}));
